import { ReportType } from 'src/graphql';
import * as Types from 'src/types';

export const isNonEditableNotificationEmail = (report: ReportType) => {
  const isVaultTalkReport =
    report?.submissionMode === Types.SUBMISSION_MODE.VAULT_TALK;
  const isOPRReport =
    report?.submissionMode === Types.SUBMISSION_MODE.OPEN_REPORTING;
  const isMIReport = report?.submissionMode === Types.SUBMISSION_MODE.MCC;
  const isMIExternalReporter = isMIReport && !report.Reporter?.eid;

  const nonEditableNotificationEmail = Boolean(
    isVaultTalkReport || isOPRReport || isMIExternalReporter,
  );

  return nonEditableNotificationEmail;
};
